export const API_URL = process.env.NODE_ENV === 'production' 
    ? "http://nvpet.novograd.info/chatbot/api" // Адреса твого бекенду на сервері коледжу
    : "http://172.20.10.4/backend"; // Адреса для локальної розробки залишаєтьсят